import { Box } from "@mui/material";
import PageTopBar from "../../../components/common/PageTopBar";
import { UserRole } from "../../../modules/common/shared/types";
import { getLoggedInUserRole } from "../../../modules/common/user/UserService"
import { AdminFeeDuesView } from "../components/AdminFeeDuesView";
import { StudentFeeDues } from "../components/StudentFeeDues";


export const FeeDuesC = () => {

  const role = getLoggedInUserRole();
  if (role === UserRole.ADMIN)
    return <AdminFeeDuesView />
  // Faculty: view-only, and the grade list holds only the grades they teach (backend enforces it too)
  if (role === UserRole.FACULTY)
    return <AdminFeeDuesView canPay={false} />
  // Student: their own dues, no filters
  if (role === UserRole.STUDENT)
    return (
      <Box sx={{ mt: 2, mr: 2 }}>
        <PageTopBar left="Outstanding" />
        <StudentFeeDues />
      </Box>
    );
}
